@use "styles/abstracts/variables" as v;

// Override maplibregl-map and maplibregl-ctrl-bottom-right styles
:global {
    .maplibregl-map{
        position: static;
        z-index: auto;
        background: transparent;
    }

    .maplibregl-canvas,
    .maplibregl-canvas-container {
        background: transparent;
    }
}

.currentPinIcon {
    cursor: pointer;
}